import CryptoJS from "crypto-js";
import { AES_CONFIG } from "../config/aes-config";

/**
 * Generates API key using HMAC-SHA256 with timestamp
 * Matches the backend generateApiKey function
 * @param timeStamp - ISO 8601 timestamp string
 * @returns Object containing apiKey and stringToSign
 */
export const generateApiKey = (timeStamp?: string): { apiKey: string; stringToSign: string } => {
  try {
    // Use current timestamp if not provided
    const timestamp = timeStamp || new Date().toISOString();
    
    // Create string to sign (timestamp or empty string)
    const stringToSign = timestamp || '';
    
    // Generate HMAC-SHA256 using AES_IV as secret
    const secret = AES_CONFIG.IV; // Same as backend process.env.APP_AES_IV
    const apiKey = CryptoJS.HmacSHA256(stringToSign, secret).toString(CryptoJS.enc.Base64);
    
    return { 
      apiKey, 
      stringToSign: timestamp 
    };
  } catch (error) {
    console.error("API Key generation error:", error);
    throw new Error("Failed to generate API key");
  }
};

/**
 * Generates current timestamp in ISO 8601 format
 * Matches backend Moment(new Date()).format()
 * @returns ISO 8601 timestamp string
 */
export const generateTimestamp = (): string => {
  return new Date().toISOString();
};

/**
 * Generates API key with current timestamp
 * Convenience function for most use cases
 * @returns Object containing apiKey, stringToSign, and timestamp
 */
export const generateApiKeyWithTimestamp = (): { 
  apiKey: string; 
  stringToSign: string; 
  timestamp: string; 
} => {
  const timestamp = generateTimestamp();
  const { apiKey, stringToSign } = generateApiKey(timestamp);
  
  return {
    apiKey,
    stringToSign,
    timestamp
  };
};
